export const throttle = <A>(func: (args: A) => void, timeout: any): (args: A) => void => {
  let ready = true;
  return (...args) => {
    if (!ready) {
      return;
    }

    ready = false;
    func(...args);
    setTimeout(() => {
      ready = true;
    }, timeout);
  };
};

export const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const parseDate = (date: any) => {
  const newDate = new Date(date);
  let day;
  if (date) {
    day = date[8] && date[8] !== '0' ? date[8] + date[9] : date[9];
  }
  else {
    day = newDate.getDate();
  }

  const month = newDate.getMonth();
  const year = newDate.getFullYear();
  return `${day} ${monthNames[month]} ${year}`;
};
